import HelpIcon from '@mui/icons-material/Help'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import NewReleasesIcon from '@mui/icons-material/NewReleases'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function HelpMenu(): JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { t } = useTranslation()

  const handleHelpClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleHelpClose = (): void => {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <IconButton
        id="help-menu-button"
        aria-haspopup="true"
        aria-label={t('helpMenuAriaLabel')}
        aria-controls={open ? 'help-menu' : undefined}
        aria-expanded={open}
        onClick={handleHelpClick}
        size="small"
        disableRipple
        disableFocusRipple
        sx={styles.iconButtonSx}
      >
        <HelpIcon fontSize="small" sx={{ color: '#f9a825' }} />
        <KeyboardArrowDownIcon fontSize="small" sx={{ color: '#616161' }} />
      </IconButton>

      <Menu
        id="help-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleHelpClose}
        MenuListProps={{
          'aria-labelledby': 'help-menu-button',
        }}
      >
        <MenuItem
          component="a"
          href="https://ppsupport.statsutah.net/hc/en-us"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleHelpClose}
          sx={styles.helpMenuItemSx}
        >
          <ListItemIcon>
            <HelpIcon color="warning" />
          </ListItemIcon>
          <ListItemText primary={t('helpCenter')} />
        </MenuItem>
        <MenuItem
          component="a"
          href="https://ppsupport.statsutah.net/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleHelpClose}
          sx={styles.helpMenuItemSx}
        >
          <ListItemIcon>
            <SupportAgentIcon color="action" />
          </ListItemIcon>
          <ListItemText primary={t('submitATicket')} />
        </MenuItem>
        <MenuItem
          component="a"
          href="https://ppsupport.statsutah.net/hc/en-us/categories/46300054557069-Personal-Property-Release-Information"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleHelpClose}
          sx={styles.helpMenuItemSx}
        >
          <ListItemIcon>
            <NewReleasesIcon color="success" />
          </ListItemIcon>
          <ListItemText primary={t('releaseNotes')} />
        </MenuItem>
      </Menu>
    </React.Fragment>
  )
}

const styles = {
  helpMenuItemSx: {
    color: 'text.primary',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'action.hover',
    },
  },
  iconButtonSx: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.15,
    border: '1px solid rgba(0,0,0,0.25)',
    borderRadius: 1,
    backgroundColor: '#ffffff',
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.05)',
    px: 0.55,
    py: 0.4,
    '&:hover': {
      backgroundColor: '#ffffff',
    },
    '&:active': {
      backgroundColor: '#ffffff',
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#ffffff',
    },
  },
}
